<template>
  <div>
    <div class="scroll-goods">
      <div class="row-title-box">
          <div class="row-title" v-if="title">{{title}}</div>
<!--          <div class="row-stitle" v-if="stitle">{{stitle}}</div>-->
      </div>
      <div class="scroll-box">
        <div
          class="scroll-one"
          v-for="(item, index) in content"
          @click="goGoodsDetail(item.url.name, item.url.query.id)"
        >
          <img :src="item.goods.pic_url" />
          <div class="scroll-goods-name show-one-row">{{item.goods.title}}</div>
          <div class="scroll-goods-price-box">
            <div class="scroll-goods-price">
              <div class="goods-list0-price">¥</div>
              <div class="goods-list1-price">{{item.goods.price_range[0]}}</div>
              <div
                v-if="item.goods.price_range_2"
                class="goods-list0-price"
              >.{{item.goods.price_range_2}}</div>
            </div>
            <!-- <div class="scroll-goods-item0-seller-price"> -->
              <div class="scroll-goods-item0-seller-price" v-if="item.goods.max_seller_reward>0">

              <div class="fan">赚</div>
              <div class="seller-price">¥{{item.goods.max_seller_reward/100}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.row-title-box{
    display: flex;
    align-items: center;
}
.scroll-goods-price{
    display: flex;
    justify-content: center;
    align-items: center;
}
.scroll-goods-price div{
    display:flex;
    height: 18px;
    align-items: flex-end;
}
.scroll-goods-item0-seller-price .fan{
  background: #FD2840;
  color: #fff;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}
.scroll-goods-item0-seller-price .seller-price{
  color: #FD2840;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}
.goods-list0-price{
    font-size: 10px;
}
.goods-list1-price{
    font-size: 14px;
}
.scroll-goods {
  background: #fff;
  margin: 0 auto;
  overflow: hidden;
  width: 7.1rem;
}

.row-title {
  padding: 0.2rem 0;
  font-size: 16px;
  height: 22px;
  display: flex;
  align-items: flex-end;
}
.row-stitle {
  padding: 0.2rem 0;
  height: 22px;
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  margin-left: 3px;
}

.scroll-box {
  padding-bottom:12.5px;
  width: 100%;
  display: inline;
  white-space: nowrap;
  overflow-x: scroll;
  float: left;
  overflow-y: hidden;
}

.scroll-one {
  width: 85px;
  margin-left: 10px;
  display: inline-block;
}

.scroll-one img {
  width: 85px;
  height: 85px;
  display: block;
}

.scroll-goods-name {
  padding: 0 5px;
  font-size: 12px;
  white-space: pre-wrap;
}
.show-one-row {
      overflow: hidden;
    text-overflow: ellipsis;
    /* display: -webkit-box; */
    -webkit-box-orient: vertical;
    /* -webkit-line-clamp: 1; */
    height: 40px;
    border-radius: 0 0 0.1rem 0.1rem;
    /* background: #666666; */
    color: #000;
}

.show-two-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 32px;
}

.scroll-goods-price {
  font-size: 14px;
  color: #fd2840;
  text-align: center;
}

.scroll-goods-item0{
  overflow: hidden;
  border-radius: 5px;
}
.scroll-goods-item0-seller-price{
  display: flex;
  justify-content: space-between;
  border: 1px solid #FD2840;
  border-radius: 4px;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
}
.scroll-goods-item0-seller-price .fan{
  background: #FD2840;
  color: #fff;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}
.scroll-goods-item0-seller-price .seller-price{
  color: #FD2840;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}

.scroll-goods-price-box{
  display: flex;
  justify-content: space-evenly;
  margin-top: 0.1rem;
}
.goods-item0-seller-price{
  padding: 0 2px;
}
</style>

<script>
export default {
  name: "GoodsList0",
  components: {},
  props: {
    content: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ""
    },
  },

  data: function() {
    return {
    };
  },

  methods: {
    goGoodsDetail(url, id) {
      rbLink({
        name:url.substring(0, 1).toUpperCase() + url.substring(1),
        query: {
          id: id
        }
      });
     
    }
  },

  filters: {}
};
</script>




// WEBPACK FOOTER //
// GoodsList0.vue?5010015d